import { render, staticRenderFns } from "./ManageDistrict.vue?vue&type=template&id=6d87a192&scoped=true&"
import script from "./ManageDistrict.vue?vue&type=script&lang=js&"
export * from "./ManageDistrict.vue?vue&type=script&lang=js&"
import style0 from "./ManageDistrict.vue?vue&type=style&index=0&id=6d87a192&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d87a192",
  null
  
)

export default component.exports